import { z } from 'zod';

import { LanguageEnum, LevelEnum, ToneModeEnum } from '../enums';

export const levelEnumValidator = z.nativeEnum(LevelEnum, {
  errorMap: () => ({
    message: `Invalid level provided. Allowed values are: ${Object.values(LevelEnum).join(', ')}`,
  }),
});

export const languageEnumValidator = z.nativeEnum(LanguageEnum, {
  errorMap: () => ({
    message: `Invalid language provided. Allowed values are: ${Object.values(LanguageEnum).join(', ')}`,
  }),
});

export const toneModeEnumValidator = z.nativeEnum(ToneModeEnum, {
  errorMap: () => ({
    message: `Invalid tone mode provided. Allowed values are: ${Object.values(ToneModeEnum).join(', ')}`,
  }),
});
